import type { Run, RerunMode } from "../../lib/types.js";
import styles from "./RerunBar.module.css";

interface RerunBarProps {
  run: Run;
  selectedSlugs: Set<string>;
  onRerun: (mode: RerunMode, slug?: string, url?: string) => void;
  isRunning?: boolean;
}

export function RerunBar({ run, selectedSlugs, onRerun, isRunning }: RerunBarProps) {
  const failedCount = run.summary?.failed ?? 0;

  return (
    <div className={styles.bar}>
      <div className={styles.buttons}>
        <button
          className={styles.btn}
          onClick={() => onRerun("all")}
          disabled={isRunning}
        >
          {isRunning ? <span className={styles.spinner} /> : "↺"} Rerun all
        </button>
        {failedCount > 0 && (
          <button
            className={`${styles.btn} ${styles.btnWarn}`}
            onClick={() => onRerun("failed")}
            disabled={isRunning}
          >
            ↺ Rerun failed ({failedCount})
          </button>
        )}
        {selectedSlugs.size > 0 && (
          <button
            className={`${styles.btn} ${styles.btnAccent}`}
            onClick={() => onRerun("check")}
            disabled={isRunning}
          >
            ↺ Rerun selected ({selectedSlugs.size})
          </button>
        )}
      </div>
      {run.parentRunId && (
        <span className={styles.meta}>↩ rerun of #{run.parentRunId.slice(0, 8)}</span>
      )}
    </div>
  );
}
